export const Providers = [
  { label: "Google", value: "google" },
  { label: "Apple", value: "apple" },
  { label: "Phone", value: "phone" },
];
